export default "__VITE_ASSET__C7F336pC__"